import React from "react";
import Container from "Components/Container/Container";
import { Link } from "react-router-dom";
const Hero = ({ background }) => {
  return (
    <section className="map background flex items-center justify-center pt-32 lg:pt-40 lg:pb-20 overflow-hidden">
      {/* <div className="absolute w-[98.8vw] z-[100] h-[100vh] left-0 top-0 bg-[#0000009c]"></div> */}
      {background && (
        <div className="absolute inset-0 z-[10]">
          <img
            className="h-[100vh] w-full object-cover"
            src={background}
            alt=""
          />
        </div>
      )}
      <Container>
        <div className="relative z-[100]">
          <div className="text-2xl  text-[#808080] flex items-center  gap-x-2">
            <Link to={"/"} className="hover:underline">
              Home
            </Link>
            <span>|</span>
            <Link to={"/main-products"} className="hover:underline">
              {" "}
              Brands
            </Link>
          </div>

          <h2 className="text-white text-5xl md:text-7xl lg:text-8xl bebas uppercase mt-2 tracking-[8px] lg:tracking-[12px]">
            Our Solutions
          </h2>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
